module.exports = __webpack_public_path__ + "img/logo.0a928426.svg";